/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Badge, Card, Modal, Row, CardBody, CardHeader, Container, Form } from 'reactstrap';
import { Link } from "react-router-dom";
import axios from 'axios';
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile"
// import SweetAlert from "react-bootstrap-sweetalert";
import PerfectScrollbar from "react-perfect-scrollbar";
import "../Style.css"

const IndexKasbon = () => {
    const warehouse = localStorage.warehouse;
    const token = localStorage.token;
    const username = localStorage.username;
    // const [activeTab, setActiveTab] = useState('1');
    // const redirectPrefix = `/mobile/dispensasi-karyawan/izin/detail/`;
    // const [alert, setAlert] = React.useState(null);
    const [allKasbon, setAllKasbon] = useState([]);
    const [modalTutorial, setModalTutorial] = useState(false);


    useEffect(() => {
        getKasbon();
    }, []);

    const getKasbon = () => {
        let filter = {
            page: 1,
            per_page: 500,
            warehouse_id: parseInt(warehouse),
            username: username
        }
        const data = filter;
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
        axios.post(`${process.env.REACT_APP_API_BASE_URL}/cash-bon/page`, data, {
            headers
        })
            .then(data => {
                setAllKasbon(data.data.response);
            })
            .catch(function (error) {
                setAllKasbon(error.response.data.response)
            })
    }

    // const setSuccessAlert = (id) => {
    //     setAlert(
    //         <SweetAlert
    //             danger
    //             showConfirm
    //             confirmBtnText="Ok"
    //             title={id}
    //             onCancel={hideAlert}
    //             onConfirm={hideAlert}
    //         />
    //     )
    // }

    // const hideAlert = () => {
    //     setAlert(null);
    // }

    return (
        <div style={{ overflow: "hidden" }}>
            {/* {alert} */}
            <SimpleHeaderMobile to="/mobile/staff-absen" />
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            <CardHeader>
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <h2 className="mb-0 d-flex align-items-center">
                                        Histori Pinjaman
                                        <i
                                            className="fa fa-question-circle ml-2 text-info"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setModalTutorial(true)}
                                            title="Lihat Tutorial"
                                        />
                                    </h2>

                                </div>
                            </CardHeader>
                            <CardBody>
                                {allKasbon === null ? (
                                    <div className="d-lg-none d-xl-none">
                                        <CardHeader>
                                            <center><h3>DATA NOT FOUND</h3></center>
                                        </CardHeader>
                                    </div>
                                ) : (
                                    // <PerfectScrollbar>
                                    //     <div className=" d-lg-none d-xl-none" style={{ top: 100, zIndex: "3", maxHeight: "35rem", paddingTop: "0.5rem" }}>
                                    //         <Form >
                                    //             <div>
                                    //                 {allKasbon.map((v) => (
                                    //                     <Link
                                    //                         to={redirectPrefix + v.id}
                                    //                         id={"tooltip_" + v.id}
                                    //                     >
                                    //                         <Card className="bg-gradient-info" style={{ marginBottom: "0.5rem" }}>
                                    //                             <CardBody>
                                    //                                 <Row>
                                    //                                     <div className="col">
                                    //                                         <CardTitle className="h5 text-uppercase text-muted mb-0 text-white">
                                    //                                             {v.ijin_date}
                                    //                                         </CardTitle>
                                    //                                         <div>
                                    //                                             <span style={{
                                    //                                                 overflow: "hidden",
                                    //                                                 textOverflow: "ellipsis",
                                    //                                                 display: "-webkit-box",
                                    //                                                 lineClamp: 1,
                                    //                                                 WebkitLineClamp: 1,
                                    //                                                 WebkitBoxOrient: "vertical",
                                    //                                             }}
                                    //                                                 className="h5 font-weight-bold mb-0 text-white ">
                                    //                                                 {v.keterangan}
                                    //                                             </span>
                                    //                                         </div>
                                    //                                     </div>
                                    //                                     <Col className="col-auto">
                                    //                                         {
                                    //                                             v.approve === 3
                                    //                                                 ? <div className="icon icon-shape bg-white text-yellow rounded-circle shadow">
                                    //                                                     <i className="fa fa-question" />
                                    //                                                 </div>
                                    //                                                 : v.approve === 4
                                    //                                                     ? <div className="icon icon-shape bg-white text-red rounded-circle shadow">
                                    //                                                         <i className="fa fa-times" />
                                    //                                                     </div>
                                    //                                                     : <div className="icon icon-shape bg-white text-green rounded-circle shadow">
                                    //                                                         <i className="fa fa-check" />
                                    //                                                     </div>
                                    //                                         }
                                    //                                     </Col>
                                    //                                 </Row>
                                    //                             </CardBody>
                                    //                         </Card>
                                    //                     </Link>
                                    //                 ))
                                    //                 }
                                    //             </div>
                                    //         </Form>
                                    //     </div>
                                    // </PerfectScrollbar>
                                    <Form>
                                        <PerfectScrollbar>
                                            <div
                                                className="d-lg-none d-xl-none"
                                                style={{ top: 100, zIndex: 3, maxHeight: "35rem", paddingTop: "0.5rem" }}
                                            >
                                                {allKasbon.map((v) => {
                                                    let badgeColor = "secondary";
                                                    let badgeText = "Baru";
                                                    let dynamicLink = "/mobile/kasbon/detail/" + v.id;
                                                    let onClickAction = () => { };

                                                    if (v.approve === 3 && v.active_flag === 1 && v.status_d === 3) {
                                                        badgeColor = "warning";
                                                        badgeText = "Proses";
                                                        dynamicLink = "/mobile/kasbon/edit/" + v.id;
                                                    } else if (v.approve === 5 && v.active_flag === 3 && v.status_d === 3) {
                                                        badgeColor = "warning";
                                                        badgeText = "Proses";
                                                        dynamicLink = "/mobile/kasbon/detail/" + v.id;
                                                    } else if (v.approve === 4 && v.active_flag === 2 && v.status_d === 3) {
                                                        badgeColor = "danger";
                                                        badgeText = "Tolak";
                                                        dynamicLink = "/mobile/kasbon/detail/" + v.id;
                                                    } else if (v.approve === 5 && v.active_flag === 2 && v.status_d === 4) {
                                                        badgeColor = "danger";
                                                        badgeText = "Tolak";
                                                        dynamicLink = "/mobile/kasbon/detail/" + v.id;
                                                    } else if (v.approve === 5 && v.active_flag === 2 && v.status_d === 5) {
                                                        badgeColor = "success";
                                                        badgeText = "Lunas";
                                                        dynamicLink = "/mobile/kasbon/detail/" + v.id;
                                                    } else if (v.approve === 5 && v.active_flag === 4 && v.status_d === 5) {
                                                        badgeColor = "warning";
                                                        badgeText = "Cicilan";
                                                        dynamicLink = "/mobile/kasbon/detail/" + v.id;
                                                    }

                                                    return (
                                                        // 
                                                        <Link to={dynamicLink} key={v.id} onClick={onClickAction}>
                                                            <Card className="bg-gradient-info mb-3 shadow border-0">
                                                                <CardBody className="p-3">
                                                                    <Row>
                                                                        <div className="col">
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <h5 className="text-white mb-1">{v.created_at}</h5>
                                                                                <Badge color={badgeColor} pill>
                                                                                    <b>{badgeText}</b>
                                                                                </Badge>
                                                                            </div>
                                                                            <div
                                                                                className="text-white font-weight-bold"
                                                                                style={{
                                                                                    overflow: "hidden",
                                                                                    textOverflow: "ellipsis",
                                                                                    display: "-webkit-box",
                                                                                    WebkitLineClamp: 1,
                                                                                    WebkitBoxOrient: "vertical",
                                                                                }}
                                                                            >
                                                                                {v.judul}
                                                                            </div>
                                                                        </div>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        </Link>
                                                    );
                                                })}
                                            </div>
                                        </PerfectScrollbar>
                                    </Form>
                                )}
                            </CardBody>
                        </Card>
                    </div>
                </Row>
            </Container>
            <Modal isOpen={modalTutorial} toggle={() => setModalTutorial(false)}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-title-default">
                        💰 Tutorial Pengajuan Pinjaman
                    </h5>
                    <button
                        aria-label="Close"
                        className="close"
                        type="button"
                        onClick={() => setModalTutorial(false)}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <p><strong>1. Pengajuan Pinjaman:</strong> Klik tombol <i className="fa fa-plus" /> untuk mengajukan pinjaman baru.</p>
                    <p><strong>2. Batas Maksimal:</strong> Jumlah pinjaman maksimal adalah <strong>Rp 1.000.000</strong>.</p>
                    <p><strong>3. Tenor dan Potongan:</strong> Pinjaman akan dipotong secara otomatis setiap bulan sesuai tenor yang dipilih.</p>
                    <ul>
                        <li>Tenor 1 bulan: Dipotong penuh di bulan berikutnya.</li>
                        <li>Tenor 2 bulan: Dipotong 50% setiap bulan.</li>
                    </ul>
                    <p><strong>4. Status Pinjaman:</strong></p>
                    <ul>
                        <li><Badge color="warning">Proses</Badge>: Menunggu persetujuan.</li>
                        <li><Badge color="danger">Ditolak</Badge>: Pengajuan ditolak.</li>
                        <li><Badge color="success">Disetujui</Badge>: Pinjaman disetujui dan siap dicairkan.</li>
                    </ul>
                    <p><strong>5. Riwayat:</strong> Semua pengajuan pinjaman akan tercatat di halaman ini sesuai statusnya.</p>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setModalTutorial(false)}>
                        Tutup
                    </button>
                </div>
            </Modal>

            <div className="d-lg-none d-xl-none">
                <Link
                    style={{
                        paddingTop: 20,
                        height: 70,
                        width: 70,
                        borderRadius: "50%",
                    }}
                    className="btn-danger text-center fixed-whatsapp encepnurdin"
                    to="/mobile/kasbon/create"
                >
                    <i className="fa fa-plus fa-2x" aria-hidden="true" />
                </Link>
            </div>
        </div>
    );
}

export default IndexKasbon;